module.exports = __webpack_public_path__ + "static/media/storefront-fallback-brand-refresh.e1cc4f48.png";